import type { JiraVersionDetailsCollapsedUi } from './__generated__/ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection.graphql';

export const checkIsCollapsed = (
	collapsedUis: readonly (JiraVersionDetailsCollapsedUi | null | undefined)[] | null | undefined,
	type: JiraVersionDetailsCollapsedUi,
): boolean => (collapsedUis ?? []).includes(type);
